import { combineReducers } from 'redux';
import dashboardReducer, {
  DASHBOARD_REDUCER_KEY,
} from '@client/redux/dashboard/dashboardReducer';
import loggedInUserReducer, {
  LOGGED_IN_USER_REDUCER_KEY,
} from '@client/redux/loggedInUser/loggedInUserReducer';
import notificationReducer, {
  NOTIFICATION_REDUCER_KEY,
} from '@client/redux/notification/notificationReducer';
import campaignReducer, {
  CAMPAIGN_REDUCER_KEY,
} from '@client/redux/campaign/campaignReducer';
import { INFLUENCER_REDUCER_KEY } from '@client/redux/influencer/influencerReducer';
import influencerReducer from '@client/redux/influencer/influencerReducer';
import participantReducer, {
  PARTICIPANT_REDUCER_KEY,
} from '@client/redux/participant/participantReducer';
import advertiserReducer, {
  ADVERTISER_REDUCER_KEY,
} from './advertiser/advertiserReducer';
import adminReducer from './admin/adminReducer';
import { ADMIN_REDUCER_KEY } from './admin/adminReducer';

export default function createRootReducer(injectedReducers = {}, initialState) {
  const reducers = {
    [CAMPAIGN_REDUCER_KEY]: campaignReducer,
    [INFLUENCER_REDUCER_KEY]: influencerReducer,
    [PARTICIPANT_REDUCER_KEY]: participantReducer,
    [ADVERTISER_REDUCER_KEY]: advertiserReducer,
    [NOTIFICATION_REDUCER_KEY]: notificationReducer,
    [LOGGED_IN_USER_REDUCER_KEY]: loggedInUserReducer,
    [NOTIFICATION_REDUCER_KEY]: notificationReducer,
    [DASHBOARD_REDUCER_KEY]: dashboardReducer,
    [ADMIN_REDUCER_KEY]: adminReducer,
    ...injectedReducers,
  };

  // If initialState contains state we have not loaded the reducer-code for yet,
  // make sure we preserve that state by creating an empty reducer for it
  if (initialState) {
    const reducerNames = Object.keys(reducers);
    Object.keys(initialState).forEach((initialStateKey) => {
      if (reducerNames.indexOf(initialStateKey) === -1) {
        reducers[initialStateKey] = (state = null) => state;
      }
    });
  }

  return combineReducers(reducers);
}
